import {
  defaultGroupedFilter,
  GroupedFilter,
} from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { useCallback, useMemo, useState } from 'react';

export type PeopleListPageParams = {
  filter: GroupedFilter;
  groupBy?: string;
  searchQuery?: string;
  role?: number;
};
export const noRoleId = -1;

export const useAccountPeoplePageParams = () => {
  const [filter, setFilter] = useState<GroupedFilter>(
    defaultGroupedFilter(FilterGroupType.User),
  );
  const [groupBy, setGroupBy] = useState<string>();
  const [searchQuery, setSearchQuery] = useState<string>();
  const [role, setRole] = useState<number>(noRoleId);
  const onParamsChange = useCallback(
    (params: Partial<PeopleListPageParams>) => {
      if (params.filter) {
        setFilter(params.filter);
      }
      if (params.groupBy !== undefined) {
        setGroupBy(params.groupBy);
      }
      if (params.searchQuery !== undefined) {
        setSearchQuery(params.searchQuery);
      }
      if (params.role !== undefined) {
        setRole(params.role);
      }
    },
    [setFilter, setGroupBy, setSearchQuery, setRole],
  );
  const resetParams = useCallback(() => {
    setFilter(defaultGroupedFilter(FilterGroupType.User));
    setGroupBy(undefined);
    setSearchQuery(undefined);
  }, [setFilter, setGroupBy, setSearchQuery]);

  return {
    params: useMemo(
      () => ({
        filter,
        groupBy,
        searchQuery,
        role,
      }),
      [filter, groupBy, searchQuery, role],
    ),
    onParamsChange,
    resetParams,
  };
};
